<template>
  <b-row>
    <b-col cols="12" md="6" lg="4" class="mc-readonly" v-for="item in items" :key="item.key">
      <div class="mc-readonly__label">{{ item.label }}</div>
      <div :class="`mc-readonly__value${item.bold ? '-bold' : ''}`">{{ item.value }}</div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.mc-readonly {
  &__label {
    // Secondary/Navy/Navy 40
    color: $mep-color-text-200;
  }

  &__value {
    // Secondary/Navy/Navy 60
    color: $mep-color-text-300;
  }
  &__value-bold {
    // Secondary/Navy/Navy 80
    color: $mep-color-text-400;
    font-weight: 600;
  }
}
</style>
